import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';


const BudgetTypeField = ({ source = 'budget_type', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const choices = {
		'generic': translate('Generic'),
		'maintenance': translate('Maintenance'),
		'production': translate('Production')
	};

	const value = record[source];

	if (!value) {
		return null;
	}

	return (
		<Typography variant="body2">{choices[value] || value}</Typography>
	);
};

export default BudgetTypeField;
